<template>
  <div>
    <v-tabs
      v-model="active"
      fixed-tabs
      color="primary" dark
      slider-color="cyan lighten-5">
      <v-tab :key="0"> Cases </v-tab>
      <v-tab :key="1"> Clients </v-tab>
      <v-tab :key="2"> Services </v-tab>
      <v-tab :key="3"> Client services </v-tab>
      <v-tab :key="4"> Service groups </v-tab>
      <v-tab :key="5"> Stats </v-tab>
      <v-tab :key="6"> Contractors </v-tab>
      <v-tab-item :key="0">
        <cases v-if="active === 0"
               :services="services"
               :servicesById="servicesById"
               :clientsById="clientsById"
               :clients="clients"
               :clientServicesByClientId="clientServicesByClientId"
               :cases="cases"
               :casesTotal="casesTotal"
               :availableCaseStatusesByValue="availableCaseStatusesByValue"
               :availableCaseStatuses="availableCaseStatuses"
               @casesReceived="handleCasesReceived"
               @removedServiceFromCase="handleRemoveServiceFromCase"
               @addedServiceToCase="handleAddServiceFromCase"
               @updatedCaseService="handleUpdateCaseService"
               @caseFieldUpdated="handleCaseFieldUpdated"
               @caseUpdated="handleCaseUpdated"
               @requestedQuantityChanged="handleRequestedQuantityChanged"
               @executedQuantityChanged="handleExecutedQuantityChanged"/>
      </v-tab-item>
      <v-tab-item :key="1">
        <clients v-if="active === 1"
                 :items="clients"
                 :caseOriginators="caseOriginators"
                 :caseOriginatorsById="caseOriginatorsById"
                 :availableReportSendModes="availableReportSendModes"
                 :availableSpecialistRole="availableSpecialistRole"
                 :clientServicesByClientId="clientServicesByClientId"
                 :servicesById="servicesById"
                 :availableContractors="availableContractors"
                 @clientCreated="handleClientCreatedEvent"
                 @clientUpdated="handleClientUpdatedEvent"
                 @clientDeleted="handleClientDeletedEvent"
                 @clientSpecialistCreated="handleClientSpecialistCreated"
                 @clientSpecialistUpdated="handleClientSpecialistUpdated"
                 @clientSpecialistDeleted="handleClientSpecialistDeleted"
                 @clientServiceUpdated="handleClientServiceUpdatedEvent"
                 @clientServiceDeleted="handleClientServiceDeleted"/>
      </v-tab-item>
      <v-tab-item :key="2">
        <client-service-prices
          @createdClientService="handleClientServiceCreatedEvent"
          @updatedClientService="handleClientServiceUpdatedEvent"
          @handleClickCreateService="handleClickCreateServiceEvent"
          :availableClients="clients"
          :availableServices="services"
          :servicesByClients="servicesByClients"
        />
        <services
          :items="services"
          :availableContractors="availableContractors"
          :servicesIdWithClients="servicesIdWithClients"
          :clickExternalCreateServices="clickExternalCreateServices"
          @serviceCreated="handleServiceCreatedEvent"
          @serviceUpdated="handleServiceUpdatedEvent"
          @serviceDeleted="handleServiceDeletedEvent"
        />
      </v-tab-item>
      <v-tab-item :key="3">
        <client-service-prices
          @createdClientService="handleClientServiceCreatedEvent"
          @updatedClientService="handleClientServiceUpdatedEvent"
          @handleClickCreateService="handleClickCreateServiceEvent"
          :availableClients="clients"
          :availableServices="services"
          :servicesByClients="servicesByClients"/>
      </v-tab-item>
      <v-tab-item :key="4">
        <service-groups v-if="active === 4" :items="availableServiceGroups"/>
      </v-tab-item>
      <v-tab-item :key="5">
        <stats v-if="active === 5"/>
      </v-tab-item>
      <v-tab-item :key="6">
        <contractors v-if="active === 6"
          :items="availableContractors"
          :availableServices="availableServices"
          :availableClients="availableClients"
          :clientServicesByClientId="clientServicesByClientId" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import api from '../api'
import Services from './Sales/Services'
import Clients from './Sales/Clients'
import ClientServicePrices from './Sales/ClientServicePrices'
import Cases from './Sales/Cases'
import Stats from './Sales/Stats'
import ServiceGroups from './Sales/ServiceGroups'
import Contractors from './Sales/Contractors'
import {caseService} from '../application'
import _ from 'lodash'

function findCase(cases, caseId) {
  let caseIndex = _.findIndex(cases, item => item.id === caseId)

  if (caseIndex < 0) {
    return
  }

  return cases[caseIndex]
}

function findCaseService(cases, caseId, serviceId) {
  const caseObj = findCase(cases, caseId)
  if (!caseObj) {
    return
  }

  let serviceIndex = _.findIndex(caseObj.services, item => item.serviceId === serviceId)
  if (serviceIndex < 0) {
    return
  }

  return caseObj.services[serviceIndex]
}

export default {
  name: 'SalesPage',
  components: {
    Clients,
    Services,
    ClientServicePrices,
    Cases,
    Stats,
    ServiceGroups,
    Contractors
  },
  data() {
    return {
      active: null,
      loading: false,
      services: [],
      clients: [],
      caseOriginators: [],
      availableReportSendModes: [
        {
          name: 'Manual',
          value: 'manual'
        },
        {
          name: 'Auto',
          value: 'auto'
        }
      ],
      availableSpecialistRole: [
        {
          name: 'Specialist',
          value: 'specialist'
        },
        {
          name: 'Administrator',
          value: 'administrator'
        }
      ],
      availableCaseStatuses: [],
      availableCaseStatusesByValue: {},
      servicesByClients: {},
      cases: [], // todo(egor) move to state of store
      casesTotal: 0, // todo(egor) move to state of store
      clickExternalCreateServices: false
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push({name: 'Login'})
    }
  },
  mounted() {
    this.active = '0'
    this.getInitialData()
  },
  computed: {
    ...mapState({
      availableServiceGroups: 'availableServiceGroups',
      availableContractors: 'availableContractors',
      availableServices: 'availableServices',
      availableClients: 'availableClients'
    }),
    servicesIdWithClients() {
      return _.keys(this.servicesByClients)
    },
    clientsById() {
      return _.keyBy(this.clients, 'id')
    },
    servicesById() {
      return _.keyBy(this.services, 'id')
    },
    caseOriginatorsById() {
      return _.keyBy(this.caseOriginators, 'id')
    },
    clientServicesByClientId() {
      let clientServicesByClientId = {}
      _.forOwn(this.servicesByClients, function(service) {
        _.forOwn(service, function(clientService) {
          let clientId = clientService.clientId
          if (!clientServicesByClientId[clientId]) {
            clientServicesByClientId[clientId] = []
          }
          clientServicesByClientId[clientId].push(clientService)
        })
      })

      return clientServicesByClientId
    }
  },
  methods: {
    ...mapActions({
      getInitialDataFromExternalSource: 'commonGetInitialData'
    }),
    async getAvailableClients() {
      try {
        this.clients = await api.getAvailableClients()
      } catch (e) {
        this.$snotify.error('Unable to get available clients', {
          showProgressBar: false
        })
      }
    },
    async getInitialData() {
      let initialData = await this.getInitialDataFromExternalSource()

      this.services = _.get(initialData, 'availableServices', [])
      this.clients = _.get(initialData, 'availableClients', [])
      this.caseOriginators = _.get(initialData, 'availableCaseOriginators', [])
      this.availableCaseStatuses = _.get(initialData, 'availableCaseStatuses', [])
      this.availableCaseStatusesByValue = _.keyBy(this.availableCaseStatuses, 'value')
      this.servicesByClients = _.get(initialData, 'servicesByClients', {})
    },
    handleClientCreatedEvent() {
      this.getAvailableClients()
    },
    handleClientUpdatedEvent(updatedClient) {
      let index = _.findIndex(this.clients, function(item) {
        return item.id === updatedClient.id
      })

      if (index < 0) {
        this.getAvailableClients()
        return
      }

      this.$set(this.clients, index, updatedClient)
    },
    async getAvailableServices() {
      try {
        this.services = await api.getAvailableServices()
      } catch (e) {
        this.$snotify.error('Unable to get available services', {
          showProgressBar: false
        })
      }
    },
    async handleServiceCreatedEvent() {
      await this.getAvailableServices()
    },
    async handleServiceDeletedEvent(deletedService) {
      let index = _.findIndex(this.services, function(item) {
        return item.id === deletedService.id
      })

      if (index < 0) {
        await this.getAvailableServices()
        return
      }

      this.$delete(this.services, index)
    },
    async handleServiceUpdatedEvent(updatedService) {
      let index = _.findIndex(this.services, function(item) {
        return item.id === updatedService.id
      })

      if (index < 0) {
        await this.getAvailableServices()
        return
      }

      this.$set(this.services, index, updatedService)
    },
    handleClientServiceCreatedEvent(createdClientService) {
      let serviceClients = this.servicesByClients[createdClientService.serviceId]

      if (serviceClients == null) {
        serviceClients = {
          [createdClientService.clientId]: createdClientService
        }
        this.$set(this.servicesByClients, createdClientService.serviceId, serviceClients)
      } else {
        this.$set(serviceClients, createdClientService.clientId, createdClientService)
      }
    },
    handleClientServiceUpdatedEvent(updatedClientService) {
      let serviceClients = this.servicesByClients[updatedClientService.serviceId]
      if (serviceClients == null) {
        console.log('Unable to find service clients')
        return
      }

      serviceClients[updatedClientService.clientId] = updatedClientService
      this.$set(this.servicesByClients, updatedClientService.serviceId, serviceClients)
    },
    handleClientDeletedEvent(deletedClient) {
      let index = _.findIndex(this.clients, function(item) {
        return item.id === deletedClient.id
      })

      if (index < 0) {
        this.getAvailableClients()
        return
      }

      this.$delete(this.clients, index)
    },
    handleCasesReceived({cases, casesTotal}) {
      this.cases = cases
      this.casesTotal = casesTotal
    },
    handleRemoveServiceFromCase({caseId, caseServiceId}) {
      let caseIndex = _.findIndex(this.cases, function(item) {
        return item.id === caseId
      })

      if (caseIndex < 0) {
        return
      }

      let c = this.cases[caseIndex]

      let serviceIndex = _.findIndex(c.services, function(item) {
        return item.id === caseServiceId
      })

      if (serviceIndex < 0) {
        return
      }

      c.services.splice(serviceIndex, 1)

      this.$set(this.cases, caseIndex, c)
    },
    handleAddServiceFromCase(addedItem) {
      let index = _.findIndex(this.cases, function(item) {
        return item.id === addedItem.caseId
      })

      if (index < 0) {
        return
      }

      let c = this.cases[index]
      c.services.push(addedItem)

      this.$set(this.cases, index, c)
    },
    handleUpdateCaseService(updatedItem) {
      let caseIndex = _.findIndex(this.cases, function(item) {
        return item.id === updatedItem.caseId
      })

      if (caseIndex < 0) {
        return
      }

      let c = this.cases[caseIndex]

      let serviceIndex = _.findIndex(c.services, function(item) {
        return item.id === updatedItem.id
      })

      if (serviceIndex < 0) {
        return
      }

      this.$set(c.services, serviceIndex, updatedItem)
    },
    handleCaseFieldUpdated({caseId, fieldName, fieldValue}) {
      let caseIndex = _.findIndex(this.cases, function(item) {
        return item.id === caseId
      })

      if (caseIndex < 0) {
        return
      }

      let c = this.cases[caseIndex]
      this.$set(c, fieldName, fieldValue)
    },
    handleCaseUpdated(c) {
      let caseIndex = _.findIndex(this.cases, function(item) { // todo(egor): use mutations
        return item.id === c.id
      })

      if (caseIndex < 0) {
        return
      }

      this.cases.splice(caseIndex, 1)
      this.$set(this.cases, caseIndex, c)
    },
    handleClientSpecialistCreated(specialist) {
      let clientIndex = _.findIndex(this.clients, function(item) {
        return item.id === specialist.clientId
      })

      if (clientIndex < 0) {
        return
      }

      let client = this.clients[clientIndex]

      let specialists = client.specialists
      specialists.push(specialist)

      this.$set(client, 'specialists', specialists)
    },
    handleClientSpecialistUpdated(specialist) {
      let clientIndex = _.findIndex(this.clients, function(item) {
        return item.id === specialist.clientId
      })

      if (clientIndex < 0) {
        return
      }

      let client = this.clients[clientIndex]

      let clientSpecialistIndex = _.findIndex(client.specialists, function(item) {
        return item.id === specialist.id
      })

      if (clientSpecialistIndex < 0) {
        return
      }

      this.$set(client.specialists, clientSpecialistIndex, specialist)
    },
    handleClientSpecialistDeleted(specialist) {
      let clientIndex = _.findIndex(this.clients, function(item) {
        return item.id === specialist.clientId
      })

      if (clientIndex < 0) {
        return
      }

      let client = this.clients[clientIndex]

      let clientSpecialistIndex = _.findIndex(client.specialists, function(item) {
        return item.id === specialist.id
      })

      if (clientSpecialistIndex < 0) {
        return
      }

      client.specialists.splice(clientSpecialistIndex, 1)

      this.$set(this.clients, clientIndex, client)
    },
    handleClientServiceDeleted(clientService) {
      let serviceClients = this.servicesByClients[clientService.serviceId]
      if (serviceClients == null) {
        console.log('Unable to find service clients')
        return
      }

      this.$delete(serviceClients, clientService.clientId)
    },
    handleRequestedQuantityChanged({caseId, serviceId, newQuantity}) {
      caseService
        .getCase({caseId: caseId})
        .then(caseInfo => {
          let caseObj = findCase(this.cases, caseId)
          caseObj.price = caseInfo.price
        })
      const serviceObj = findCaseService(this.cases, caseId, serviceId)
      serviceObj.quantity = newQuantity
    },
    handleExecutedQuantityChanged({caseId, serviceId, newQuantity}) {
      const serviceObj = findCaseService(this.cases, caseId, serviceId)
      serviceObj.executedQuantity = newQuantity
    },
    handleClickCreateServiceEvent() {
      this.clickExternalCreateServices = !this.clickExternalCreateServices
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SalesPage.vue